import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../../../../Global/axios";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import CostSheetCreate from "./CostSheetCreate";
import CostSheetEdit from "./CostSheetEdit";

export default function CostSheetSteps({
  costSheetForm,
  updateCostSheetForm,
  govtFee,
  salaryAllowance,
  slaFees,
  quotationType,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const [list, setList] = useState([]);
  console.log(list, "list");
  let quotationDetails = {
    number: list?.quotation?.quotation_number,
    name: list?.quotation?.name,
    type: list?.quotation_type,
    hour_type: list?.hour_type,
    clientName: list?.client,
    clientSpecific: list?.quotation?.client?.client_specific,
  };
  if (costSheetForm.method === "Create") {
    quotationDetails = {
      number: list?.quotation_number,
      name: list?.name,
      type: list?.quotation_type?.name,
      hour_type: list?.hour_type,

      clientName: list?.client?.name,
      clientSpecific: list?.client?.client_specific,
    };
  }
  const [costSheetState, setCostSheetState] = useState({
    // currentStep:
    //   costSheetForm.method === "Edit"
    //     ? 2
    //     : costSheetForm.method === "Create" && 1,
    currentStep: 2,
    govtFee:
      quotationDetails.type === "Cost Plus" ? "onetime_cost" : "monthly_cost",
    salaryAllowance: salaryAllowance || "monthly_cost",
    slaFees: slaFees || "monthly_cost",
  });
  const currentQuotationId =
    location.state?.quotationId || location.pathname.split("/")[3];

  const step1SubmitHandler = (govtFee, salaryAllowance, slaFees) => {
    setCostSheetState((p) => ({
      ...p,
      currentStep: 2,
      govtFee,
      salaryAllowance,
      slaFees,
    }));
  };

  const [QUOTATION_DETAILS_2, SET_QUOTATION_DETAILS] = useState();

  useEffect(() => {
    if (costSheetForm.method === "Edit") {
      axios
        .get(`/dashboard/quotation/${currentQuotationId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setList(res.data.data);
          SET_QUOTATION_DETAILS(res.data.data);
          setCostSheetState((p) => ({
            ...p,
            govtFee:
              res.data.data?.quotation_type === "Cost Plus"
                ? "onetime_cost"
                : "monthly_cost",
          }));
        })
        .catch((err) => {
          if (err.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err.response?.data?.message,
              })
            );
          }
        });
    } else if (costSheetForm.method === "Create") {
      axios
        .get(`/dashboard/quotation/${location?.state?.quotationId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setList(res.data.data);
          setCostSheetState((p) => ({
            ...p,
            govtFee:
              res.data.data?.quotation_type?.name === "Cost Plus"
                ? "onetime_cost"
                : "monthly_cost",
          }));
        })
        .catch((err) => {
          if (err.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err.response?.data?.message,
              })
            );
          }
        });
    }
  }, []);

  return (
    <>
      {costSheetState.currentStep === 2 &&
        costSheetForm.method === "Create" && (
          <CostSheetCreate
            quotationDetails={quotationDetails}
            quotationId={location.pathname.split("/")[3]}
            updateCostSheetForm={updateCostSheetForm}
          />
        )}
      {costSheetState.currentStep === 2 && costSheetForm.method === "Edit" && (
        <CostSheetEdit
          QUOTATION_DETAILS={QUOTATION_DETAILS_2}
          costSheetId={costSheetForm?.costSheetId}
          quotationDetails={quotationDetails}
          quotationId={location.pathname.split("/")[3]}
          updateCostSheetForm={updateCostSheetForm}
        />
      )}
    </>
  );
}
